/**
 * 权限指令注册 - Vuex版本
 */
import store from '@/store'

export default {
  install(Vue) {
    // 添加全局权限检查方法
    Vue.prototype.$permission = function(permission) {
      return store.getters['permission/hasPermission'](permission)
    }
    
    // 添加全局CSS样式来确保权限隐藏的元素完全不可见
    const style = document.createElement('style')
    style.textContent = `
      [data-permission-hidden="true"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        pointer-events: none !important;
        height: 0 !important;
        width: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        overflow: hidden !important;
        position: absolute !important;
        left: -9999px !important;
        top: -9999px !important;
      }
    `
    document.head.appendChild(style)
    
    // 权限检查方法
    function checkPermission(el, binding) {
      const { value } = binding
      
      // 如果权限为 null 或 undefined，跳过处理
      if (value === null || value === undefined) return
      
      // 如果权限字符串为空，显示按钮
      if (value === '') {
        el.style.display = ''
        return
      }
      
      // 检查权限数据是否已加载
      const permissions = store.state.permission.rolePermissions
      const isPermissionsLoaded = permissions !== null && permissions !== undefined
      
      // 如果权限数据还未加载完成，隐藏元素，避免无权限用户看到按钮
      if (!isPermissionsLoaded) {
        el.style.display = 'none'
        return
      }
      
      let hasAccess = false
      
      if (typeof value === 'string') {
        // 单个权限
        hasAccess = store.getters['permission/hasPermission'](value)
      } else if (Array.isArray(value)) {
        // 多个权限，默认OR逻辑
        hasAccess = store.getters['permission/hasAnyPermission'](value)
      } else if (typeof value === 'object' && value.permissions) {
        // 对象形式，支持OR/AND逻辑
        if (value.type === 'and') {
          hasAccess = store.getters['permission/hasAllPermissions'](value.permissions)
        } else {
          hasAccess = store.getters['permission/hasAnyPermission'](value.permissions)
        }
      }
      
      if (!hasAccess) {
        el.style.display = 'none'
        el.style.visibility = 'hidden'
        el.style.opacity = '0'
        el.style.pointerEvents = 'none'
        el.style.height = '0'
        el.style.width = '0'
        el.style.padding = '0'
        el.style.margin = '0'
        el.style.overflow = 'hidden'
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        el.style.top = '-9999px'
        el.setAttribute('data-permission-hidden', 'true')
      } else {
        el.style.display = ''
        el.style.visibility = ''
        el.style.opacity = ''
        el.style.pointerEvents = ''
        el.style.height = ''
        el.style.width = ''
        el.style.padding = ''
        el.style.margin = ''
        el.style.overflow = ''
        el.style.position = ''
        el.style.left = ''
        el.style.top = ''
        el.removeAttribute('data-permission-hidden')
      }
    }
    
    // 添加权限加载完成监听器
    function addPermissionListener(el, binding) {
      const listener = () => {
        checkPermission(el, binding)
      }
      
      // 存储监听器引用，用于清理
      el._permissionListener = listener
      
      // 监听权限加载完成事件
      Vue.prototype.$bus.$on('permissions-loaded', listener)
    }

    Vue.directive('permission', {
      inserted(el, binding) {
        checkPermission(el, binding)
        // 监听权限加载完成事件
        addPermissionListener(el, binding)
      },
      
      update(el, binding) {
        checkPermission(el, binding)
      },
      
      unbind(el) {
        // 清理事件监听
        if (el._permissionListener) {
          Vue.prototype.$bus.$off('permissions-loaded', el._permissionListener)
        }
      }
    })
  }
}
